import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Спортивный туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Вид активного отдыха- участие в спортивных мероприятиях; активные и целенаправленные виды
                        физической подготовки и упражнений, тренировки, например плавание, бег, велосипедные прогулки и
                        др.</p>
                    <p><img src={require('./../img/dj.jpg')}/></p>
                </div>
            </div>
        </>
    );
}